import { render, staticRenderFns } from "./add-manual-check-to-batch.vue?vue&type=template&id=5ded0019"
import script from "./add-manual-check-to-batch.vue?vue&type=script&lang=js"
export * from "./add-manual-check-to-batch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports